<template>
  <div class="sidecart_empty">
    <div v-for="block in blocks" v-html="blockToOutput(block)">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cart_empty',
    props: ['blocks'],
    methods: {
      blocksToOutput: function(blocks) {
        return; 
      },
      blockToOutput: function(block) {
        const { type, ...settings } = block;
        switch (type) {
          case 'button_link':
            return `<a href="${ settings.link }" class="button _secondary _strong">${ settings.title }</a>`;
            break;
          case 'message':
            return `<div class="sidecart_empty_text">${ settings.text }</div>`;
            break;
        }
      }
    }
  }
</script>